import React, { useState } from "react";

export function AspectRatioImage({ src, alt }) {
  const [aspectRatio, setAspectRatio] = useState(1);

  return (
    <div
      className="w-full max-w-[600px] bg-gray-100 rounded-lg overflow-hidden relative"
      style={{ aspectRatio }}
    >
      <img
        src={src}
        alt={alt}
        className="absolute inset-0 w-full h-full object-contain"
        onLoad={(e) => {
          const img = e.target;
          setAspectRatio(img.naturalWidth / img.naturalHeight);
        }}
      />
    </div>
  );
}
